// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '08c3d9b',
    builtAt: '2026-09-08T11:01:22.161Z',
} as const;
